import { Toaster as Sonner, toast } from "sonner"
import { Check, CircleAlert, TriangleAlert, Info, Loader2 } from "lucide-react"

// Graphite's pop-up notifications: a dark panel in both themes (like Graphite's header, footer and announcement
// bar), 10px corners, no shadow. The type is a line icon and a word in the status colour ("Success:", "Error:",
// index.css), then the message in white: never a tinted box. Success is blue (Graphite's success colour, on purpose).
const DARK = { bg: "#141414", border: "#141414" }  // the handoff's toast: no edge, 8px corners, 12px 16px
const GRAPHITE_TOASTS = {
  "--normal-bg": DARK.bg, "--normal-border": DARK.border, "--normal-text": "#FFFFFF",
  "--success-bg": DARK.bg, "--success-border": DARK.border, "--success-text": "#6FC3F2",
  "--error-bg": DARK.bg, "--error-border": DARK.border, "--error-text": "#FF8A5B",
  "--warning-bg": DARK.bg, "--warning-border": DARK.border, "--warning-text": "#FFB938",
  "--info-bg": DARK.bg, "--info-border": DARK.border, "--info-text": "#CCCCCC",
  "--border-radius": "8px",
}
const icon = { className: "w-4 h-4", strokeWidth: 1.5 }
const ICONS = {
  success: <Check {...icon} />,
  error: <CircleAlert {...icon} />,
  warning: <TriangleAlert {...icon} />,
  info: <Info {...icon} />,
  loading: <Loader2 {...icon} className="w-4 h-4 animate-spin" />,
}

const Toaster = ({ style, ...props }) => (
  <Sonner
    theme="dark"
    richColors
    icons={ICONS}
    className="toaster group"
    style={{ ...GRAPHITE_TOASTS, ...style }}
    toastOptions={{
      style: { padding: "12px 16px", gap: "8px", fontSize: "13px", boxShadow: "none", maxWidth: "460px" },
      classNames: {
        description: "group-[.toast]:text-[#CCCCCC]",
        actionButton: "group-[.toast]:bg-white group-[.toast]:text-black",
        cancelButton: "group-[.toast]:bg-[#262626] group-[.toast]:text-white",
      },
    }}
    {...props} />
)

export { Toaster, toast }
